/**
 * 2019-11-06
 * handan
 * 浏览器相关信息
 */
import axios from "axios";

let config = {
	apihost : "//kshi.58.com" ,
	jsonphost : "//kshi.58.com"
}

const ajax = (url, method = "get", params = {}, options = {}) => {
  // 首先判断是get请求还是post请求
  let data = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
  return axios({
    url: config.apihost + url,
    method,
    timeout: 3000,
    [data]: params,
    ...options,
  }).then((res) => {
    let { data = {} } = res || {} ;
    if(data.code * 1 === 200){
      return Promise.resolve(data.data || {});
    }else{
      return Promise.reject(data.msg || "接口数据异常");
    }
  }).catch((err) => {
    return Promise.reject(err);
  })
}

export default {

  setBrowserInfo(params) {
    return new Promise((resolve, reject) => {
      ajax("/v1/saveUser", "post", params, {withCredentials: true})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err)
      })
    })
  },
  setBrowserInfoDate(params){
    return new Promise((resolve, reject) => {
      ajax("/v1/updateUserDate", "post", params, {withCredentials: true})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err)
      })
    })
  },
  setUserTime(params) {
    return new Promise((resolve, reject) => {
      ajax("/v1/setUseTime", "post", params, {withCredentials: true})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err)
      })
    })
  },
  getUseTimeGray(){
    return new Promise((resolve, reject) => {
      ajax("/v1/getUseTimeGray", "get")
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err)
      })
    })
  }
}